<template>
    <div v-if="config.display" :style="{'width': config.width || ''}" class="control e-control">
        <ejs-button v-bind="syncfusionConfig"
                    v-on:click="action($event, 'onclick'); localClick($event)"
                    :ref="config.ref || config.id"
                    :title="config.hideTitle ? '' : ddStoreFilter(config.title || config.label)"
                    :disabled="isProcessing || config.disabled"
                    :display="config.display"
                    :processing="isProcessing"
                    :data-test-id="dataTestId"
                    :style="{'background-color': config.backgroundColor || '', 'border-color': config.borderColor || '', 'color': config.textColor || ''}"
        >
            <icon v-if="config.icon" :name="config.icon?.name" :size="config.icon?.size" :color="config.icon?.color"></icon>
            <span v-if="config.actionIcon" :style="config.label ? 'margin-right:8px;' : 'margin-right:0;'"><i :class="config.actionIcon"></i></span>
            <span v-if="!config.hideLabel" :style="{'text-transform': config.textTransform || ''}">{{ ddStoreFilter(config.label) }}</span>
            <div v-if="isProcessing" class="processing-effect"></div>
            <div v-if="isProcessing" class="processing-opacity"></div>
        </ejs-button><sam-tooltip
        v-if="labelSettings.helpText"
        ref="tooltip"
        opensOn="Click"
        :css-class="labelSettings.tooltipClasses"
        :content="labelSettings.helpText"
        :label-classes="labelSettings.tooltipLabelClasses"
    ></sam-tooltip>
    </div>
</template>

<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { controlMixins } from "./controlMixins.js";

let editorSettings = {
    onclick: {
        type: 'actionfield',
        label: 'Click Action',
        itemsSource: 'actionStore.getActionOptions()',
        fields: {
            text: 'text',
            value: 'value'
        },
        default: {
            action: '',
            params: {}
        }
    },
    text: {
        type: "boolean",
        label: "Show button as link",
        default: false
    },
    color: {
        type: "dropdown",
        label: "Button color",
        default: "primary",
        fields: { text: 'text', value: 'value' },
        items: [
            { text: "Primary", value: "primary" },
            { text: "Warning", value: "warning" },
            { text: "Error", value: "danger" },
        ]
    }
};

export const buttonComponent = {
    editorSettings: editorSettings,
    mixins: [controlMixins],
    computed: {
        isProcessing() {
            return this.config.processing || false;
        },
        labelSettings() {
            let tooltipId = (this.name || this.id) + '_tooltip';
            let tooltipPosition = ' TopCenter';
            return {
                tooltipClasses: 'label-wrapper-tooltip ' + tooltipId + tooltipPosition,
                tooltipLabelClasses: 'e-icons e-info help-tooltip ' + tooltipId,
                helpText: this.config.helpText
            };
        }
    },
    methods: {
        localClick(event) {
            if (typeof event === 'object' && typeof event?.currentTarget?.blur === 'function') {
                event.currentTarget.blur();
            }
        }
    },
    components: {
        "ejs-button": defineAsyncComponent(() => import('@common/syncfusion/button')),
        'sam-tooltip': defineAsyncComponent(() => import('@common/control/samTooltip')),
        "icon": defineAsyncComponent(() => import('@common/icon/Icon')),
    }
};

export default buttonComponent;
</script>

<style scoped>
:deep(.e-icons.e-close:before) {
    content: '\ec0f' !important;
}

:deep(.e-icons.e-arrow-right:before){
    content: '\e913' !important;
}

:deep(.e-icons.e-arrow-left:before){
    content: '\e904' !important;
}

:deep(.e-icons.close:before){
    content: '\e842' !important;
}
:deep(.e-tooltip) {
    margin-left: 10px;
}

:deep(button) {
    position: relative;
    overflow: hidden;
}

:deep(button[processing="true"]) {
    cursor: progress !important;
    border: none !important;
}

.processing-effect {
    position: absolute;
    inset: 0;
    z-index: 1;
    background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.25) 50%,
        rgba(255, 255, 255, 0) 100%
    );
    opacity: 0;
    transition: 0.3s;
}

:deep(button[processing="true"] .processing-opacity) {
    position: absolute;
    inset: 0;
    background: rgb(141 141 141 / 30%)
}

:deep(button[processing="true"] .processing-effect) {
    opacity: 1;
    animation: process 1s linear infinite;
}

@keyframes process {
    0% {
        transform: translateX(-100%);
    }
    100% {
        transform: translateX(100%);
    }
}

</style>
